<template>
    <nav class="navbar"
         :class="[
            {'navbar-expand-lg': expand},
            {[`navbar-${effect}`]: effect},
            {'navbar-transparent': transparent},
            {[`bg-${type}`]: type},
            {'rounded': round}
         ]">
        <div class="container-fluid">
            <slot name="container-pre"></slot>

            <navbar-toggle-button :toggled="toggled"
                                  :target="contentId"
                                  @click.native.stop="toggled = !toggled">
            </navbar-toggle-button>

            <slot name="container-after"></slot>

          <div class="d-block d-sm-none ml-2 mr-2">
            <a class="btn side4" target="_blank" href="https://cp.dzenburo.ru/backend/pdf_portfolio/all.pdf">
             <i class="fa fa-file-pdf-o"></i>
            </a>
            <router-link to="/service/1" class="btn btn-success" tag="button">Заказать</router-link>

            <a slot="title" v-if="user_is_login" href="#" class="btn side4" @click="loadNotify"  role="button">
              <i class="ni ni-ui-04 d-lg-none"></i>
              <span class="nav-link-inner--text"><i class="fa fa-bell"></i>  <badge v-if="notify_count>0"
                                                                                    type="danger">{{
                  notify_count
                }}</badge></span>
            </a>

          </div>
<!--          <div class="d-block d-sm-none">-->
<!--            <router-link :to="{name: 'shop_cart'}" class="btn btn" tag="button"><i class="ni ni-cart"></i><span v-if="cart.length>0" class="badge badge-warning">{{ cart.length}}</span></router-link>-->


<!--          </div>-->

            <div class="collapse navbar-collapse" :class="{show: toggled}" :id="contentId" v-click-outside="closeMenu">
              <navbar-toggle-button :type_button="'close'" :toggled="toggled"
                                    :target="contentId"
                                    @click.native.stop="toggled = !toggled">
              </navbar-toggle-button>
              <div class="navbar-collapse-header">

                    <slot name="content-header" :close-menu="closeMenu"></slot>


                </div>
                <slot :close-menu="closeMenu"></slot>

            </div>
        </div>
    </nav>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import NavbarToggleButton from "./NavbarToggleButton";
import {eventBus} from '@/main.js';
import Api  from "@/models/Api.js";
import UserModel from "../models/UserModel";

export default {
  name: "base-nav",
  components: {
    FadeTransition,
    NavbarToggleButton
  },
  props: {
    type: {
      type: String,
      default: "primary",
      description: "Navbar type (e.g default, primary etc)"
    },
    title: {
      type: String,
      default: "",
      description: "Title of navbar"
    },
    contentId: {
      type: [String, Number],
      default: Math.random().toString(),
      description:
        "Explicit id for the menu. By default it's a generated random number"
    },
    effect: {
      type: String,
      default: "dark",
      description: "Effect of the navbar (light|dark)"
    },
    round: {
      type: Boolean,
      default: false,
      description: "Whether nav has rounded corners"
    },
    transparent: {
      type: Boolean,
      default: false,
      description: "Whether navbar is transparent"
    },
    expand: {
      type: Boolean,
      default: false,
      description: "Whether navbar should contain `navbar-expand-lg` class"
    }
  },
  data() {
    return {
      'cart':[],
      'user':null,
      'user_is_login':false,
      'notify_count':0,
      toggled: false
    };
  },
  mounted() {
     var app=this;
    var tmpUser=UserModel.get();
    if(tmpUser) {
      if (tmpUser.api_token) {
        app.user=tmpUser;
        app.user_is_login=true;

      }
    }
    eventBus.$on("update_notify_count",function(params){
      app.notify_count=params.notify_count;
    });
     app.cart=Api.getCart();
    eventBus.$on("sync_cart",cart=>{

      app.cart=cart;
    });
  },
  methods: {
    loadNotify() {
      var app = this;
      app.$router.push({"name": "notify", "params": { "rand": Math.random()}});
    },
    onTitleClick(evt) {
      this.$emit("title-click", evt);
    },
    closeMenu() {
      this.toggled = false;
    }
  }
};
</script>
<style>
</style>
